import axios from 'axios';

import * as config from 'config';

const authApi = axios.create({
  baseURL: config.AUTH_URL
});

const ontruckApi = axios.create({
  baseURL: config.API_URL
});

export { authApi, ontruckApi };
